
import { FeedbackBadgeType } from "./feedbackBadges";

export enum SpecType {
    SYSTEM_DESIGN = 'system design',
    SOFTWARE_CONCEPTS = 'software concepts',
    CODING = 'coding',
    PRODUCT_DESIGN = 'product design',
    ESTIMATION = 'estimation',
    STRATEGY = 'strategy',
    ROLE = 'role',
    GENERAL = 'general',
    RESUME_BASED = 'resume based',
    ORG = 'org',
    DOMAIN = 'domain',
    JOB_DESCRIPTIONQ = 'jobDescriptionQ',
    CUSTOM="custom"
}

export enum type{
    CUSTOM="custom",
    RETRY="retry",
    BEHAVIORAL = 'behavioral',
    TECHNICAL = 'technical',
    BOTH = "both",
    ESSENTIAL = 'general'
}

export enum track{
    CUSTOM="custom",
    PACK = 'pack',
    COMPANY = 'domain',
    RESUME_BASED = 'resume based',
    JOB_DESCRIPTIONQ = 'jobDescriptionQ',
    ORG = 'org',
    RESUMED = 'resumed session',
    BITESIZED= 'bitesized'
}

export interface DBQuestions{
    id: string,
    questions: string[]
}

export interface Question{
    question: string, 
    level: string | null,
    domain: string,
    type: string,
    specType: string,
    subCategories: string[]
}

export interface SessionQuestion{
    question: Question, 
    feedback: string, 
    actionsteps: string, 
    prompt: GPTResponse[];
    fullprompt: GPTResponse[]; 
    samplesolution: string, 
    code: string,
    useWhiteboard: boolean, 
    codingLang: string, 
    time: number, 
    isHelpful: boolean|null,
    isHelpfulMessage: string | null,
    intQuestion?: number,
    role: string,
    feedbackDuration: number,
    sessionId: string,
    biteSizeOptions?: BiteSizeOption[],
    videoid?: string,
}

export type BiteSizeOption = {
    label:string,
    info?: string,
    value: string,
    response: string
}

export type AdminViewHistory = {
  studentName: string;
  goToMembers: ()=>void;
  studentInfo: MemberInfo
}

export type MemberInfo = {
    answeredQuestions: AnsweredQuestions;
    interviewsCompleted: number;
    avgInterviewScore: number;
    totalStars: number;
    topPath: string;
}

export type MemberReportInfo = {
    interviewsCompleted: number;
    avgInterviewScore: number;
    topPath: string;
    email: string;
}

export type FeedbackType = {
  title: string;
  badgeType: FeedbackBadgeType;
  desc: string;
}[];

export type MicOpts = {
  stopMic: () => void;
  sttFromMic: () => void;
  micListening: boolean;
  processing: boolean
};

export interface ITrackSessionQuestions {
  [key: string]: {
    color: string;
    questions: ITrackQuestion[];
  }
};

export interface ITrackQuestion {
    question: Question;
    selected: boolean;
    tag: string;
    tagColor: string;
    difficulty: string;
    noOfStars: number;
};

export interface User {
  resumetext: string;
  resumename: string;
  name: string;
  email: string;
  email_verified: boolean;
  audioEnabled: boolean;
  intakeForm: FormData;
  id:string;
  oid: string;
  referralCode: string;
  subscription: string;
  hasActiveSubscription: boolean;
  questionsLeft: number;
  joinDate: string;
  isLegacyUser?: boolean;
  answeredQuestions?: AnsweredQuestions; 
  resumeQuestions?: string[];
  freeForPartnership?: boolean;
  organization?: string;
  JobDescriptions?: StringDictionary;
  JDQuestions?: StringDictionary;
  lastPath?: string;
  interviewsCompleted: number,
  avgInterviewScore: number,
  totalStars: number;
  lastInterviewCompleteDate?: string;
  lastInterviewCompleteQ?: string;
  streak?: number;
  role? : string;
 savedSessions?: {[key:string]: {timestamp: string
    session: SessionQuestion[]
 }
}
}

export interface StringDictionary {
    [key: string]: string;
}

export interface Option {
    value: string;
    label: string;
}

export interface JobDescription {
  title: string;
  description: string;
}

export interface FormData {
    [key: string]: string | boolean | string[];
}

export interface CheckoutSession{
    clientSecret: string,
    sessionid: string
}

export interface AnsweredQuestions{
    [key: string]: InterviewObject[];
}

export interface OrganizationInfo{
    id : string,
    friendlyName : string,
    principalAdmin : string,
    currentCohort : string,
    lastUpdate: string, 
    topPracticedRole : string,
    totalInterviewsPracticed: number,
    avgInterviewScore : number,
    totalActiveLicenses: number
}

export interface AssessmentInfo
{
    questions: {time?:number, question:string}[],
    token: string,
    companyName: string,
    authorized: boolean,
    timed: boolean,
    assessmentName: string
}

export interface Member{
    email: string,
    name: string,
    year: number,
    school: string,
    id: string|null,
    membershipType: string,
    topPath: string,
    lastSession: string
}

export interface Cohort{
    id: string,
    isActive: boolean,
    totalLicenses: number,
    activeLicenses: number,
    startDate: string,
    endDate: string,
    licenseType: string,
    members: Member[]
}

export interface OrgQuestions{
    [key: string]: OrgQuestion[];
}

export interface OrgQuestion{
    question: string,
    rubric: string | null
}

export interface FeedbackUpdate{
    isHelpful: boolean | null,
    isHelpfulMessage:string | null,
    actionSteps: string,
    orgAccessible: boolean,
    samplesolution: string,
}

export interface InterviewObject{
    isHelpful: boolean | null;
    isHelpfulMessage: string | null;
    feedback:string;
    actionSteps: string;
    whiteboard? : string;
    interviewDuration?: number;
    codingLang?: string
    samplesolution? : string;
    timestamp: string;
    stars?: number;
    role: string;
    specType: string;
    domain: string;
    orgAccessible: boolean;
    feedbackGenTime: number;
    transcript: GPTResponse[];
}

export interface GPTResponse{
    role: string;
    content: string;
}

export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  cadence: string;
}

export const companyOptions: Option[] = [
    { value: "Apple Inc.", label: "Apple Inc." },
    { value: "Microsoft Corporation", label: "Microsoft Corporation" },
    { value: "Amazon.com Inc.", label: "Amazon.com Inc." },
    { value: "Alphabet Inc. (Google)", label: "Alphabet Inc. (Google)" },
    { value: "Meta Platforms, Inc. (formerly Facebook)", label: "Meta Platforms, Inc. (formerly Facebook)" },
    { value: "Samsung Electronics Co., Ltd.", label: "Samsung Electronics Co., Ltd." },
    { value: "Tencent Holdings Limited", label: "Tencent Holdings Limited" },
    { value: "Alibaba Group Holding Limited", label: "Alibaba Group Holding Limited" },
    { value: "Intel Corporation", label: "Intel Corporation" },
    { value: "Cisco Systems, Inc.", label: "Cisco Systems, Inc." },
    { value: "IBM (International Business Machines Corporation)", label: "IBM (International Business Machines Corporation)" },
    { value: "Oracle Corporation", label: "Oracle Corporation" },
    { value: "Dell Technologies Inc.", label: "Dell Technologies Inc." },
    { value: "HP Inc. (Hewlett-Packard)", label: "HP Inc. (Hewlett-Packard)" },
    { value: "Adobe Inc.", label: "Adobe Inc." },
    { value: "NVIDIA Corporation", label: "NVIDIA Corporation" },
    { value: "Netflix, Inc.", label: "Netflix, Inc." },
    { value: "PayPal Holdings, Inc.", label: "PayPal Holdings, Inc." },
    { value: "Salesforce.com, Inc.", label: "Salesforce.com, Inc." },
    { value: "SAP SE", label: "SAP SE" },
    { value: "Accenture plc", label: "Accenture plc" },
    { value: "VMware, Inc.", label: "VMware, Inc." },
    { value: "Uber Technologies, Inc.", label: "Uber Technologies, Inc." },
    { value: "Lyft, Inc.", label: "Lyft, Inc." },
    { value: "Zoom Video Communications, Inc.", label: "Zoom Video Communications, Inc." },
    { value: "Twitter, Inc.", label: "Twitter, Inc." },
    { value: "Snap Inc.", label: "Snap Inc." },
    { value: "Airbnb, Inc.", label: "Airbnb, Inc." },
    { value: "Dropbox, Inc.", label: "Dropbox, Inc." },
    { value: "Slack Technologies, Inc. (acquired by Salesforce)", label: "Slack Technologies, Inc. (acquired by Salesforce)" },
    { value: "Atlassian Corporation Plc", label: "Atlassian Corporation Plc" },
    { value: "Reddit, Inc.", label: "Reddit, Inc." },
    { value: "Pinterest, Inc.", label: "Pinterest, Inc." },
    { value: "Spotify Technology S.A.", label: "Spotify Technology S.A." },
    { value: "Square, Inc.", label: "Square, Inc." },
    { value: "Coinbase Global, Inc.", label: "Coinbase Global, Inc." },
    { value: "Twilio Inc.", label: "Twilio Inc." },
    { value: "Shopify Inc.", label: "Shopify Inc." },
    { value: "Zillow Group, Inc.", label: "Zillow Group, Inc." },
    { value: "Expedia Group, Inc.", label: "Expedia Group, Inc." },
    { value: "Booking Holdings Inc.", label: "Booking Holdings Inc." },
    { value: "eBay Inc.", label: "eBay Inc." },
    { value: "Tencent Music Entertainment Group", label: "Tencent Music Entertainment Group" },
    { value: "Electronic Arts Inc. (EA)", label: "Electronic Arts Inc. (EA)" },
    { value: "Activision Blizzard, Inc.", label: "Activision Blizzard, Inc." },
    { value: "Take-Two Interactive Software, Inc.", label: "Take-Two Interactive Software, Inc." },
    { value: "Unity Software Inc.", label: "Unity Software Inc." },
    { value: "Roblox Corporation", label: "Roblox Corporation" },
    { value: "WeWork Companies Inc.", label: "WeWork Companies Inc." }
];
